import { interfaces } from 'inversify'

import { IncidentId } from '@collector/sportsapi-client-legacy'

import { PossessionSide } from './PossessionSide/PossessionSide'

type SI<T> = interfaces.ServiceIdentifier<T>

interface SoccerRelationIoCBindingsInterface {
  PossessionSide: SI<PossessionSide>
  // TODO: move to shared bindings when it will be used in other sports
  DisabledIncidentsWithSameTime: SI<IncidentId[]>
  EnabledIncidentSequencesWithSameTime: SI<IncidentId[][]>
  ExpectedGoalsZonesMatrix: SI<number[][]>
}

export const SoccerRelationIoCBindings: SoccerRelationIoCBindingsInterface = {
  PossessionSide: Symbol('PossessionSide'),
  DisabledIncidentsWithSameTime: Symbol('DisabledIncidentsWithSameTime'),
  EnabledIncidentSequencesWithSameTime: Symbol(
    'EnabledIncidentSequencesWithSameTime',
  ),
  ExpectedGoalsZonesMatrix: Symbol('ExpectedGoalsZonesMatrix'),
}
